/**
 * Header interactive — extracted from inline <script> blocks in sections/header.liquid.
 * Handles: mobile nav drawer, megamenu (hover/click-pin/ESC/outside/scroll).
 * Loaded with `defer` so DOM is ready by the time this runs.
 */
(function () {
  // ── Mobile nav drawer (with focus trap) ──
  var mobileToggles = document.querySelectorAll('[data-mobile-menu-toggle]');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileNavPreviouslyFocused = null;
  var mobileNavTrapHandler = null;

  function trapMobileNavFocus() {
    mobileNavPreviouslyFocused = document.activeElement;
    mobileNavTrapHandler = function (e) {
      if (e.key === 'Escape') {
        closeMobileNav();
        return;
      }
      if (e.key !== 'Tab' || !mobileNav) return;
      var focusables = mobileNav.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), summary'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', mobileNavTrapHandler);
    var firstFocusable = mobileNav.querySelector('[data-mobile-menu-toggle], a[href], button:not([disabled])');
    if (firstFocusable) firstFocusable.focus();
  }

  function releaseMobileNavFocus() {
    if (mobileNavTrapHandler) {
      document.removeEventListener('keydown', mobileNavTrapHandler);
      mobileNavTrapHandler = null;
    }
    if (mobileNavPreviouslyFocused && typeof mobileNavPreviouslyFocused.focus === 'function') {
      mobileNavPreviouslyFocused.focus();
    }
    mobileNavPreviouslyFocused = null;
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mobile-nav-open');
    releaseMobileNavFocus();
  }

  if (mobileNav) {
    mobileToggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = mobileNav.getAttribute('aria-hidden') === 'true';
        mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
        document.body.classList.toggle('mobile-nav-open', open);
        if (open) {
          trapMobileNavFocus();
        } else {
          releaseMobileNavFocus();
        }
      });
    });
  }

  // ── Mega menu: hover + click-pin + ESC + outside + scroll ──
  var mega = document.querySelector('[data-megamenu]');
  if (!mega) return;
  var trigger = mega.querySelector('[data-megamenu-trigger]');
  var panel = mega.querySelector('[data-megamenu-panel]');
  var backdrop = document.querySelector('[data-megamenu-backdrop]');
  if (!trigger || !panel) return;

  var openTimer, closeTimer;
  var pinned = false;
  var scrollStartY = 0;

  function setOpen(state) {
    trigger.setAttribute('aria-expanded', state ? 'true' : 'false');
    document.body.classList.toggle('megamenu-open', state);
    if (state) scrollStartY = window.scrollY;
  }
  function isOpen() { return trigger.getAttribute('aria-expanded') === 'true'; }

  function open() {
    clearTimeout(closeTimer);
    openTimer = setTimeout(function () { setOpen(true); }, 120);
  }
  function close(immediate) {
    if (pinned) return;
    clearTimeout(openTimer);
    if (immediate) { setOpen(false); return; }
    closeTimer = setTimeout(function () { setOpen(false); }, 200);
  }
  function forceClose() {
    pinned = false;
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    setOpen(false);
  }

  // Hover
  mega.addEventListener('mouseenter', open);
  mega.addEventListener('mouseleave', function () { close(false); });

  // Click to pin / unpin
  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    if (isOpen() && pinned) { forceClose(); }
    else { pinned = true; setOpen(true); }
  });

  // ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) forceClose();
  });

  // Click outside
  document.addEventListener('click', function (e) {
    if (!isOpen()) return;
    if (mega.contains(e.target)) return;
    forceClose();
  });

  // Scroll past 50px closes
  window.addEventListener('scroll', function () {
    if (!isOpen()) return;
    if (Math.abs(window.scrollY - scrollStartY) > 50) forceClose();
  }, { passive: true });

  // Clicking a tile inside the panel navigates — let it happen, just unpin
  panel.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (link) { pinned = false; }
  });

  // Backdrop click closes
  if (backdrop) backdrop.addEventListener('click', forceClose);
})();
